/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';

import { List } from './favoriteSlice';
import styles from './FavoriteTable.module.scss';

export interface ConfirmationProps {
  row?: List;
  open: boolean;
  onClose: (row?: List) => void;
}

export default function RemoveFavoriteConfirmation(props: ConfirmationProps) {
  const { onClose, row, open } = props;

  const handleCancel = () => {
    onClose();
  };

  const handleOk = () => {
    onClose(row);
  };

  return (
    <Dialog sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 400 } }} maxWidth="xs" open={open}>
      <DialogTitle className={styles.centerText}>You are about to delete the following favorite</DialogTitle>
      <DialogContent className={styles.centerText}>
        <p>{`"${row?.title || ''}"`}</p>
      </DialogContent>
      <DialogActions className={styles.centerSelf}>
        <Button variant="outlined" color="secondary" onClick={handleCancel}>
          Cancel
        </Button>
        <Button variant="contained" autoFocus color="error" onClick={handleOk}>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}
